module.exports = __webpack_public_path__ + "img/member-team6.7fe2d4d1.jpg";